"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMedia = exports.MediaDetailProvider = void 0;

var React = _interopRequireWildcard(require("react"));

var _media = require("../../util/media");

var _photoContext = require("./photo-context");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const MediaContext = /*#__PURE__*/React.createContext({
  state: {
    media: null,
    projectTags: null,
    photoNav: null
  },
  mediaHandlers: null
});

const mediaReducer = (state, action) => {
  switch (action.type) {
    case "nochange":
      {
        return state;
      }

    case "UPDATE_MEDIA":
      return { ...state,
        media: action.payload
      };

    case "UPDATE_PROJECT_TAGS":
      return { ...state,
        projectTags: action.payload
      };

    case "UPDATE_PHOTO_NAV":
      return { ...state,
        photoNav: action.payload
      };

    default:
      {
        throw new Error(`Unhandled action type: ${action.type}`);
      }
  }
};

const MediaDetailProvider = ({
  children,
  media,
  projectTags,
  photoNav,
  renderReferences,
  editTitleHandler,
  addTagsHandler,
  removeTagsHandler,
  pageHandler,
  closeHandler,
  deleteHandler,
  downloadHandler,
  editTitleClickHandler,
  playHandler,
  zoomHandler,
  fullscreenHandler,
  shareHandler,
  editLocationHandler
}) => {
  const [state, dispatch] = React.useReducer(mediaReducer, {
    media,
    projectTags,
    photoNav
  });
  React.useEffect(() => {
    dispatch({
      type: "UPDATE_MEDIA",
      payload: media
    });
  }, [media]);
  React.useEffect(() => {
    dispatch({
      type: "UPDATE_PROJECT_TAGS",
      payload: projectTags
    });
  }, [projectTags]);
  React.useEffect(() => {
    dispatch({
      type: "UPDATE_PHOTO_NAV",
      payload: photoNav
    });
  }, [photoNav]);
  const {
    handlers: photoHandlers
  } = (0, _photoContext.usePhoto)();

  const handlePage = forward => {
    photoHandlers.resetZoom();

    if (forward) {
      photoNav[0] < photoNav[1] && pageHandler(true);
    } else {
      photoNav[0] > 1 && pageHandler(false);
    }
  };

  const mediaHandlers = {
    editTitleHandler: async (media, title) => {
      const newTitle = title ? title.trim() : (0, _media.getDefaultTitle)(media);
      await editTitleHandler(media, newTitle);
    },
    addTagsHandler,
    removeTagsHandler: tag => removeTagsHandler(media, tag),
    closeHandler,
    renderReferences,
    pageForward: () => handlePage(true),
    pageBack: () => handlePage(false),
    deleteHandler,
    playHandler,
    downloadHandler,
    editTitleClickHandler,
    fullscreenHandler,
    zoomHandler,
    editLocationHandler,
    shareHandler
  };
  const value = {
    state,
    mediaHandlers
  }; // keyboard navigation

  const navigatorEl = React.useRef(null);
  React.useEffect(() => {
    navigatorEl.current && navigatorEl.current.focus();
  }, [navigatorEl.current]);

  const navigate = e => {
    // @ts-ignore
    if (!e.target || e.target.id !== "navigator") return;

    switch (e.keyCode) {
      case 39:
        mediaHandlers.pageForward();
        break;

      case 37:
        mediaHandlers.pageBack();
        break;

      default:
    }
  };

  return /*#__PURE__*/React.createElement(MediaContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement("span", {
    ref: navigatorEl,
    tabIndex: 0,
    id: "navigator",
    onKeyDown: navigate
  }, children));
};

exports.MediaDetailProvider = MediaDetailProvider;

const useMedia = () => {
  const context = React.useContext(MediaContext);

  if (context === undefined) {
    throw new Error("useMedia must be used within a MediaDetailProvider");
  }

  return context;
};

exports.useMedia = useMedia;